<template>
  <div>
    <v-btn
      v-if="circle"
      outline
      :loading="loading"
      :disabled="loading"
      small
      fab
      color="primary"
      @click="getShopProfile"
      v-tooltip.top="$t('Print Cover')"
    >
      <span class="fa fa-print"></span>
    </v-btn>
    <v-btn
      v-else
      :loading="loading"
      :disabled="loading || orders.length == 0"
      outline
      color="grey"
      @click="getShopProfile"
    >
      <v-icon>fa fa-print</v-icon>
      &nbsp;{{ $t('Print Covers') }}
    </v-btn>
    <v-dialog v-model="showEditAddress" width="500">
      <v-card v-if="showEditAddress">
        <v-card-text>
          <div style="text-align: right">
            <v-btn @click="cancelEdit" icon>
              <v-icon>close</v-icon>
            </v-btn>
          </div>
          <div class="row">
            <!-- <div class="title">แก้ไขที่อยู่ร้านค้า</div> -->
            <div class="col s12">
              <label for="pageAddress">{{ $t('Shop Address') }}</label>
            </div>
            <div class="col s12 form-control">
              <div>
                <!-- <tooltip v-model="showSaveAddress">Saved</tooltip> -->
                <textarea
                  v-model="input.pageaddress"
                  class="form-control"
                  rows="5"
                  style="resize:vertical"
                ></textarea>
              </div>
            </div>
          </div>
          <div class="row text-xs-center">
            <div class="col s12">
              <v-btn @click="skipEdit" outline color="grey">{{ $t('skip') }}</v-btn>
              <v-btn @click="saveContent" :loading="loadingsave" depressed color="primary">
                {{ $t('Save') }}
              </v-btn>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import PrintAllCovers from './PrintAllCovers.js'
export default {
  mixins: [PrintAllCovers]
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/PrintAllCovers.vue